import { LogiSDKConfig } from '../../shares/model/config';

/* eslint-disable */
export const defaultConfig: LogiSDKConfig = {
  tenantId: '',
  otpConfig: {
    callbackFn: (nonce: string, metadata?: { gameId: string }) => {},
    remoteApiEnable: true,
    remoteApiEndPoint: '',
    requestHeaders: {},
    routeParams: {},
    queryString: {},
  },
  locale: {
    language: 'en',
    translations: {
      en: {
        'error.title': 'Error',
        'error.subTitle': 'Something went wrong!',
        'error.description':
          'Please try again later or contact support if the issue persists.',
        'error.buttonTitle': 'Try Again',
      },
    },
  },
  logging: {
    enableLogger: false,
    transmit: {
      level: 'warn',
      send: (level: string, logEvent: string) => {},
    },
  },
  onEvent: (type, event) => {},

  // swipeGames
  enableSwipeGames: true,
  swipeGames: {
    playForFunMode: true,
    enableDesktop: false,
    swipeIconCollapse: {
      enabled: false,
      collapseIconAfter: 5,
      enableCollapseMenu: false,
    },
    iconPosition: 'left',
    homeIconUrl: `${process.env.NX_HOST}/assets/img/home.svg`,
    styles: {
      iconBgColor: '',
      iconTop: 65, // 0 to 90 between
    },
    gameListConfig: {
      remoteApiEnable: true,
      remoteApiEndPoint:
        process.env.NX_GAME_LIST_API_VERSION === 'V2'
          ? process.env.NX_GAME_LIST_API_V2
          : process.env.NX_GAME_LIST_API_V1,
      requestHeaders: {},
      routeParams: {},
      queryString: { tenant: '' },
      gameList: [],
      gamesOverride: null,
    },
    gameLaunchConfig: {
      remoteApiEnable: true,
      remoteApiEndPoint: process.env.NX_LAUNCHER_URL,
      requestHeaders: {},
      routeParams: {},
      queryString: {
        tenantId: '',
      },
      initialGameLauncherUrl: '',
    },
    urlCallbackFn: null,
  },

  // miniGames
  enableMiniGames: false,
  miniGames: {
    domElement: '',
    pagesToShow: [],
    launchOnLoad: false,
    gameListConfig: {
      remoteApiEnable: true,
      remoteApiEndPoint: process.env.NX_MINIGAME_API,
      requestHeaders: {},
      routeParams: {},
      queryString: {},
      gameList: [],
      gamesOverride: null,
    },
    gameLaunchConfig: {
      remoteApiEnable: true,
      remoteApiEndPoint: process.env.NX_MINIGAME_LAUNCHER,
      requestHeaders: {},
      routeParams: {},
      queryString: {
        tenantId: '',
      },
    },
    urlCallbackFn: null,
  },

  // simulate
  enableSimulate: false,
  simulate: {
    tenantId: '',
    iframeContainerId: '',
    iframeSourceUrl: process.env.NX_SIMULATE_URL,
    pageToRedirect: '',
    source: '',
    onRefreshBalance: undefined,
    onAnimationStart: undefined,
  },

  // simulateSpecials
  enableSimulateSpecials: false,
  simulateSpecials: {
    tenantId: '',
    iframeContainerId: '',
    iframeSourceUrl: process.env.NX_SIMULATE_SPECIALS_URL,
    onRefreshBalance: undefined,
    source: undefined,
    locale: 'en',
  },
};
